import { combineReducers } from 'redux';

import {
    REQUEST_SUBSCRIBE,
    SUCCESS_SUBSCRIBE,
    FAILURE_SUBSCRIBE,
    RESET_FORM_SUBMIT_SUBSCRIBE
} from './constants';

const successSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_SUBSCRIBE:
            return true;
        case REQUEST_SUBSCRIBE:
        case FAILURE_SUBSCRIBE:
        case RESET_FORM_SUBMIT_SUBSCRIBE:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_SUBSCRIBE:
            return true;
        case FAILURE_SUBSCRIBE:
        case SUCCESS_SUBSCRIBE:
        case RESET_FORM_SUBMIT_SUBSCRIBE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_SUBSCRIBE:
            return action.response.message;
        case REQUEST_SUBSCRIBE:
        case SUCCESS_SUBSCRIBE:
        case RESET_FORM_SUBMIT_SUBSCRIBE:
            return '';
        default:
            return state;
    }
};

export default combineReducers({ successSubmit, fetching, error });



// WEBPACK FOOTER //
// ./src/services/newsletter/reducer.js